import styled from 'styled-components';

export const FormSection = styled.div`
  margin-bottom: 20px;
`;
